/**
 * Terms of Service Page — Route Module
 */
import { routes } from '@letsgethome/routes';
import { PageContainer } from '@letsgethome/ui/page-container';
import { Prose } from '@letsgethome/ui/Prose';

import { SeoHead } from '../../../../shared/components/SeoHead';
import { useStaticSeo } from '../../../../shared/hooks/seo/use-static-seo';
import { Link } from '../../../../shared/i18n/routing';
import { useTranslations } from '../../../../shared/i18n/useTranslations';

export function Component() {
  const t = useTranslations('legal.termsOfService');

  return (
    <>
      <SeoHead
        {...useStaticSeo('/terms', { title: t('seo.title'), description: t('seo.description') })}
      />
      <PageContainer size="4xl" className="py-8 sm:px-6 lg:px-8">
        <Prose>
          <h1>{t('title')}</h1>

          <p className="text-muted-foreground">{t('lastUpdated')}</p>

          <h2>{t('introductionTitle')}</h2>
          <p>{t('introduction')}</p>

          <h2>{t('disclaimerTitle')}</h2>
          <p>{t('disclaimer')}</p>

          <h2>{t('eligibilityTitle')}</h2>
          <p>{t('eligibility')}</p>

          <h2>{t('accountRegistrationTitle')}</h2>
          <p>{t('accountRegistration')}</p>

          <h2>{t('contentTitle')}</h2>
          <p>{t('content')}</p>

          <h2>{t('userObligationsTitle')}</h2>
          <p>{t('userObligations')}</p>

          <h2>{t('limitationOfLiabilityTitle')}</h2>
          <p>{t('limitationOfLiability')}</p>

          <h2>{t('governingLawTitle')}</h2>
          <p>{t('governingLaw')}</p>

          <h2>{t('changesToTermsTitle')}</h2>
          <p>{t('changesToTerms')}</p>

          <h2>{t('contactUsTitle')}</h2>
          <p>
            <Link href={routes.contact()} className="text-primary hover:underline">
              {t('contactUs')}
            </Link>
          </p>
        </Prose>
      </PageContainer>
    </>
  );
}
